import { VisibleIcon, InvisibleIcon } from "@boi/react-icons";
import { CorePasswordInput } from "@boi/components-core";

import { TooltipV2 } from "../TooltipV2";
import { IconButtonV2 } from "../IconButtonV2";

type InputType = CorePasswordInput.InputType;

type PasswordInputButtonProps = {
  type: InputType;
  setType: (type: InputType) => void;
  withTooltip?: boolean;
};

export function PasswordInputButton(props: PasswordInputButtonProps) {
  const { type, setType, withTooltip } = props;

  const label = type === "password" ? "Show password" : "Hide password";

  function handlePress() {
    setType(type === "password" ? "text" : "password");
  }

  const iconButton = (
    <IconButtonV2 onPress={handlePress} aria-label={label}>
      {type === "password" ? <VisibleIcon /> : <InvisibleIcon />}
    </IconButtonV2>
  );

  if (withTooltip) {
    return (
      <TooltipV2>
        <TooltipV2.Trigger>
          {iconButton}

          <TooltipV2.Content tooltipProps={{ offset: 6, placement: "bottom" }}>
            {label}
          </TooltipV2.Content>
        </TooltipV2.Trigger>
      </TooltipV2>
    );
  }

  return iconButton;
}
